import axios from 'axios';
import { correlationIdGenerator, GLOBAL_PREF_CODE } from '../utils/ModuleMap';
import envConfig from '../envConfig';
const USE_MOCK_SAVE_API = true; // Set to true to use mock API for testing

// export const getIDAASTokenAPI = async () => {
//   // Check cache first
//   const cachedToken = tokenCache.getCachedIdaasToken();
//   if (cachedToken) {
//     console.log('[getIDAASTokenAPI] Returning cached IDAAS token');
//     return {
//       authorization_token: cachedToken,
//       expires_in: Math.floor(
//         (tokenCache.idaasExpiresAt - Date.now()) / 1000
//       ),
//       fromCache: true,
//     };
//   }

//   // Real implementation when ready
//   try {
//     const headers = {
//       'Content-Type': 'application/json',
//       Accept: 'application/json',
//     };

//     const body = {
//       scope: ['/privacy/preferences/search::post', '/privacy/preferences::post'],
//     };

//     // Uncomment when token service is ready:
//     // const tokenResp = await axios.post(envConfig[env]?.EPCC_TOKEN_URL, body, { headers });
//     // const tokenRes = tokenResp?.data;

//     //! Mock token response for now
//     const tokenRes = {
//       authorization_token: 'mocked-token-for-testing',
//       expires_in: 3600,
//     };

//     // Cache the token
//     tokenCache.setIdaasToken(tokenRes.authorization_token, tokenRes.expires_in);

//     return tokenRes;
//   } catch (err) {
//     const errorData = {
//       message: err.message,
//       response: err.response?.data,
//       status: err.response?.status,
//       timestamp: new Date().toISOString(),
//     };
//     console.error('[getIDAASTokenAPI] Error:', errorData);
//     return { error: err, errorData };
//   }
// };

/**
 * Get IDAAS token (from cache if valid, otherwise refresh)
 * @returns {string} Authorization token
 */
// export const getIdaasTokenWithCache = () => {
//   const token = tokenCache.getCachedIdaasToken();
//   if (!token) {
//     throw new Error(
//       'IDAAS token not available. Call initializeTokenRefreshCycle() first.'
//     );
//   }
//   return token;
// };

// export const getCardTokenAPI = async (fetchClient) => {
//   try {
//     const headers = {
//       'Content-Type': 'application/json',
//       Accept: 'application/json',
//     };

//     const body = {
//       scope: ['*'],
//     };

//     // Uncomment when card token service is ready:
//     // const tokenResp = await axios.post(envConfig[env]?.CARD_API_TOKEN, body, { headers });
//     // const tokenRes = tokenResp?.data;

//     // //! Mock card token response for now
//     // const tokenRes = {
//     //   authorization_token: 'mocked-card-token-for-testing',
//     //   expires_in: 600,
//     // };

//     // Cache the card token
//     fetchClient();

//     return tokenRes;
//   } catch (err) {
//     const errorData = {
//       message: err.message,
//       response: err.response?.data,
//       status: err.response?.status,
//       timestamp: new Date().toISOString(),
//     };
//     console.error('[getCardTokenAPI] Error:', errorData);
//     return { error: err, errorData };
//   }
// };

// export const initializeCardTokenOnLoad = async (
//   dispatchFn,
//   actionType = 'SET_CARD_TOKEN',
//   fetchClient
// ) => {
//   try {
//     const cardTokenResponse = await getCardTokenAPI(fetchClient);

//     if (cardTokenResponse?.error) {
//       throw cardTokenResponse.error;
//     }

//     if (dispatchFn && actionType) {
//       dispatchFn({
//         type: actionType,
//         payload: cardTokenResponse.authorization_token,
//       });
//     }

//     return cardTokenResponse.authorization_token;
//   } catch (error) {
//     console.error('[initializeCardTokenOnLoad] Failed to initialize:', error);
//     throw error;
//   }
// };

export const postPrivacyPreferenceSearchDetails = async ({
  emailAddress,
  // appToken,
  env
}) => {
  try {
    var _envConfig$env;
    // Step 1: Get JWT
    // const tokenRes = await getApplicationToken({ appId, secret, tokenUrl: tokenUrlParam });

    // console.log('appToken:', appToken);
    // console.log('searchUrlParam:', env, envConfig[env]?.EPCC_SEARCH_URL,);

    // if (!appToken) {
    //   throw new Error('Token not received');
    // }

    // const jwt = appToken;

    // Step 2: Build search payload
    const searchPayload = {
      requestorInformation: {
        // confirm this value from Angular config
        interfaceRelationshipId: (_envConfig$env = envConfig[env]) === null || _envConfig$env === void 0 ? void 0 : _envConfig$env.EPCC_INTERFACE_RELATIONSHIP_ID
      },
      customerDetails: {
        entityClassificationCode: 'EMAIL',
        entityFormatCode: 'EMAIL',
        entityValue: emailAddress
      },
      preferenceRequestGroup: [{
        preferenceCode: GLOBAL_PREF_CODE
      }],
      auditInformation: {
        correlationId: correlationIdGenerator()
      }
    };
    const searchHeaders = {
      'Content-Type': 'application/json'
      // Authorization: `Bearer ${jwt}`,
    };
    let searchResp = null;
    if (USE_MOCK_SAVE_API) {
      searchResp = {
        data: {
          status: {
            requestTrackId: '1234',
            responseCode: 'SUCCESS'
          },
          entityPreferenceResponse: {
            entityValue: '[REDACTED_EMAIL_ADDRESS_1]',
            preferenceCodeDetails: [{
              preferenceList: [],
              preferenceCode: 'MKTGBEML',
              preferenceEffectiveTs: '2025-11-18 10:39:00.580881',
              preferenceStatus: 'I',
              prefLockInd: 'No',
              derivedIndicator: 'N'
            }]
          }
        }
      };
    } else {
      var _envConfig$env2;
      searchResp = await axios.post((_envConfig$env2 = envConfig[env]) === null || _envConfig$env2 === void 0 ? void 0 : _envConfig$env2.EPCC_SEARCH_URL, searchPayload, {
        headers: searchHeaders
      });
    }
    return searchResp.data;

    //! mock response for now
  } catch (error) {
    var _error$response, _error$response2;
    const errorData = {
      message: error.message,
      response: (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data,
      status: (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.status,
      emailAddress,
      timestamp: new Date().toISOString()
    };
    console.error('postPrivacyPreferenceSearchDetails error:', errorData);
    return {
      error,
      errorData
    };
  }
};

/**
 *
 * @returns format "YYYY-MM-DD-HH.mm.ss.SSSSSS"
 */
const formatOptioTimestamp = () => {
  const now = new Date();
  const pad = (n, width = 2) => n.toString().padStart(width, '0');
  const datePart = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
  const timePart = `${pad(now.getHours())}.${pad(now.getMinutes())}.${pad(now.getSeconds())}`;
  const microseconds = `${pad(now.getMilliseconds(), 3)}000`;
  return `${datePart}-${timePart}.${microseconds}`;
};
export const updatePrivacyPreferences = async ({
  emailAddress,
  preferenceStatus,
  // appId = privacyAppId,
  // secret = privacySecret,
  // tokenUrl: tokenUrlParam = tokenUrl,
  // updateUrl: updateUrlParam = updateUrl,
  // appToken,
  env
}) => {
  try {
    var _envConfig$env3;
    // Step 1: Get JWT
    // const tokenRes = await getApplicationToken({ appId, secret, tokenUrl: tokenUrlParam });

    // if (!tokenRes?.authorization_token) {
    //   if (tokenRes?.error) return tokenRes;
    //   throw new Error('Token not received');
    // }

    // if (!appToken) {
    //   throw new Error('Token not received');
    // }
    // const jwt = appToken;

    // Step 2: Build correct Optio update payload
    const updatePayload = {
      requestorInformation: {
        interfaceRelationshipId: (_envConfig$env3 = envConfig[env]) === null || _envConfig$env3 === void 0 ? void 0 : _envConfig$env3.EPCC_INTERFACE_RELATIONSHIP_ID
      },
      customerDetails: {
        entityClassificationCode: 'EMAIL',
        entityFormatCode: 'EMAIL',
        entityValue: emailAddress
      },
      preferenceRequestGroup: [{
        preferenceCode: GLOBAL_PREF_CODE,
        preferenceStatus: preferenceStatus === 'U' || preferenceStatus === 'O' ? 'O' : 'I',
        preferenceReceiptTime: formatOptioTimestamp()
      }],
      auditInformation: {
        correlationId: correlationIdGenerator()
      }
    };
    const updateHeaders = {
      'Content-Type': 'application/json'
      // Authorization: `Bearer ${jwt}`,
    };
    let response = null;
    if (USE_MOCK_SAVE_API) {
      response = {
        data: {
          requestTrackId: 'Dig_EML_Intl_Web-2025-12-29-16.52.24.650000',
          responseStatus: 'All Choice-Codes Processed',
          responseCode: 'SUCCESS'
        }
      };
    } else {
      var _envConfig$env4;
      response = await axios.post((_envConfig$env4 = envConfig[env]) === null || _envConfig$env4 === void 0 ? void 0 : _envConfig$env4.EPCC_UPDATE_URL, updatePayload, {
        headers: updateHeaders
      });
    }
    return response.data;
  } catch (error) {
    var _error$response3, _error$response4;
    const errorData = {
      message: error.message,
      response: (_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.data,
      status: (_error$response4 = error.response) === null || _error$response4 === void 0 ? void 0 : _error$response4.status,
      emailAddress,
      timestamp: new Date().toISOString()
    };
    console.error('updatePrivacyPreferences error:', errorData);
    return {
      error,
      errorData
    };
  }
};
export const forceOptOutForSkipMarkets = async ({
  emailAddress,
  // appToken,
  env
}) => {
  try {
    var _envConfig$env5;
    // Step 1: Get JWT
    // const tokenRes = await getApplicationToken({ appId, secret, tokenUrl: tokenUrlParam });

    // if (!tokenRes?.authorization_token) {
    //   if (tokenRes?.error) return tokenRes;
    //   throw new Error('Token not received');
    // }
    // if (!appToken) {
    //   throw new Error('Token not received');
    // }

    // const jwt = appToken;

    // Step 2: Build correct Optio update payload
    const updatePayload = {
      requestorInformation: {
        interfaceRelationshipId: (_envConfig$env5 = envConfig[env]) === null || _envConfig$env5 === void 0 ? void 0 : _envConfig$env5.EPCC_INTERFACE_RELATIONSHIP_ID
      },
      customerDetails: {
        entityClassificationCode: 'EMAIL',
        entityFormatCode: 'EMAIL',
        entityValue: emailAddress
      },
      preferenceRequestGroup: [{
        preferenceCode: GLOBAL_PREF_CODE,
        preferenceStatus: 'O',
        // force opt-out
        preferenceReceiptTime: formatOptioTimestamp()
      }],
      auditInformation: {
        correlationId: correlationIdGenerator()
      }
    };
    const updateHeaders = {
      'Content-Type': 'application/json'
      // Authorization: `Bearer ${jwt}`,
    };
    let response = null;
    if (!USE_MOCK_SAVE_API) {
      var _envConfig$env6;
      response = await axios.post((_envConfig$env6 = envConfig[env]) === null || _envConfig$env6 === void 0 ? void 0 : _envConfig$env6.EPCC_UPDATE_URL, updatePayload, {
        headers: updateHeaders
      });
    } else {
      response = {
        requestTrackId: 'Dig_EML_Intl_Web-2025-12-29-16.52.24.650000',
        responseStatus: 'All Choice-Codes Processed',
        responseCode: 'SUCCESS'
      };
    }
    return response;
  } catch (error) {
    var _error$response5, _error$response6;
    const errorData = {
      message: error.message,
      response: (_error$response5 = error.response) === null || _error$response5 === void 0 ? void 0 : _error$response5.data,
      status: (_error$response6 = error.response) === null || _error$response6 === void 0 ? void 0 : _error$response6.status,
      emailAddress,
      timestamp: new Date().toISOString()
    };
    console.error('forceOptOutForSkipMarkets error:', errorData);
    return {
      error,
      errorData
    };
  }
};